import { BaseDynamicZoneModel } from "@models/dynamic-zones";
import { StrapiGatsbyImageType } from "./common";

export enum FeatureStatsVariants {
  WITH_IMAGE = "withImage",
  WITHOUT_IMAGE = "withoutImage",
}

export enum FeatureStatsTitleOrientation {
  CENTER = "center",
  LEFT = "left",
  RIGHT = "right",
}

export interface FeatureStatsDynamicZoneModel extends BaseDynamicZoneModel {
  bgColor: string;
  tiles: Array<{ title: string; subTitle: string; id: string }>;
  statImage: StrapiGatsbyImageType | undefined;
  variants: FeatureStatsVariants;
  titleOrientation: FeatureStatsTitleOrientation;
}
